import { render } from "./LoginSmsPage.vue?vue&type=template&id=0ba0dabd&scoped=true"
import script from "./LoginSmsPage.vue?vue&type=script&lang=js"
export * from "./LoginSmsPage.vue?vue&type=script&lang=js"

import "./LoginSmsPage.vue?vue&type=style&index=0&id=0ba0dabd&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba0dabd"]])

export default __exports__